import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { TPublicationReportReportPresentationModel } from "../../../../presenter/report/model/PublicationsReportReportPresentationModel";
import DataGrid from "../../app/grid/DataGrid";

const PublicationsReportReportsGrid = ({
  translate,
  reports
}: {
  translate: TTranslate;
  reports: TPublicationReportReportPresentationModel[];
}) => {
  const columns = [
    {
      key: "version",
      dataIndex: "version",
      title: translate("publications_report.reports.version"),
      align: "right"
    },
    {
      key: "submitDate",
      dataIndex: "submitDate",
      title: translate("publications_report.reports.submit_date"),
      sorter: (a, b) =>
        DataGrid.SortHelper.compareDateString(a.submitDate, b.submitDate)
    },
    {
      key: "formalEvaluationStatus",
      dataIndex: "formalEvaluationStatus",
      title: translate("publications_report.reports.formal_evaluation_status")
    },
    {
      key: "formalEvaluationDate",
      dataIndex: "formalEvaluationDate",
      title: translate("publications_report.reports.formal_evaluation_date"),
      sorter: (a, b) =>
        DataGrid.SortHelper.compareDateString(
          a.formalEvaluationDate,
          b.formalEvaluationDate
        )
    }
  ];

  return (
    <div style={{ marginBottom: "1em" }}>
      <DataGrid
        translate={translate}
        columns={columns}
        dataSource={reports}
      ></DataGrid>
    </div>
  );
};

export default PublicationsReportReportsGrid;
